import { SelectedScreens } from '../typings/displayMap';
import { GroupId } from '../typings/groups';

export const OPEN_OUTDOOR_MAP_EDITOR = 'OPEN_OUTDOOR_MAP_EDITOR';
export type OPEN_OUTDOOR_MAP_EDITOR = typeof OPEN_OUTDOOR_MAP_EDITOR;

export interface OpenOutdoorMapEditor {
    type: OPEN_OUTDOOR_MAP_EDITOR;
    groupId: GroupId;
    checkedByRegion: SelectedScreens;
}

export function openOutdoorMapEditor(
    groupId: GroupId,
    checkedByRegion: SelectedScreens
): OpenOutdoorMapEditor {
    return {
        type: OPEN_OUTDOOR_MAP_EDITOR,
        groupId,
        checkedByRegion
    };
}

export const OUTDOOR_MAP_EDITOR_CHANGE_ITEM = 'OUTDOOR_MAP_EDITOR_CHANGE_ITEM';
export type OUTDOOR_MAP_EDITOR_CHANGE_ITEM = typeof OUTDOOR_MAP_EDITOR_CHANGE_ITEM;

export interface OutdoorMapEditorChangeItem {
    type: OUTDOOR_MAP_EDITOR_CHANGE_ITEM;
    checkedByRegion: SelectedScreens;
}

export function outdoorMapEditorChangeItem(
    checkedByRegion: SelectedScreens
): OutdoorMapEditorChangeItem {
    return {
        type: OUTDOOR_MAP_EDITOR_CHANGE_ITEM,
        checkedByRegion
    };
}

export const SAVE_OUTDOOR_MAP_ACTION = 'SAVE_OUTDOOR_MAP_ACTION';
export type SAVE_OUTDOOR_MAP_ACTION = typeof SAVE_OUTDOOR_MAP_ACTION;

export interface SaveOutdoorMapAction {
    type: SAVE_OUTDOOR_MAP_ACTION;
}

export function saveOutdoorMapAction(): SaveOutdoorMapAction {
    return {
        type: SAVE_OUTDOOR_MAP_ACTION
    };
}

export const CLOSE_OUTDOOR_MAP_EDITOR = 'CLOSE_OUTDOOR_MAP_EDITOR';
export type CLOSE_OUTDOOR_MAP_EDITOR = typeof CLOSE_OUTDOOR_MAP_EDITOR;

export interface CloseOutdoorMapEditor {
    type: CLOSE_OUTDOOR_MAP_EDITOR;
}

export function closeOutdoorMapEditor(): CloseOutdoorMapEditor {
    return {
        type: CLOSE_OUTDOOR_MAP_EDITOR
    };
}

export const CLEAR_OUTDOOR_ERRORS = 'CLEAR_INDOOR_ERRORS';
export type CLEAR_OUTDOOR_ERRORS = typeof CLEAR_OUTDOOR_ERRORS;

export interface ClearOutdoorErrors {
    type: CLEAR_OUTDOOR_ERRORS;
    id: string;
}

export function clearOutdoorErrors(id: string): ClearOutdoorErrors {
    return {
        type: CLEAR_OUTDOOR_ERRORS,
        id
    };
}

export type OpenOutdoorMapEditorAction =
    | OpenOutdoorMapEditor
    | OutdoorMapEditorChangeItem
    | SaveOutdoorMapAction
    | CloseOutdoorMapEditor
    | ClearOutdoorErrors;
